<template>
  <svg
    viewBox="0 0 28.06 47.2"
    xmlns="http://www.w3.org/2000/svg"
    class="svg-icon icon-back"
  >
    <path
      class="cls-1"
      d="M1.15,24.7a.8.8,0,0,1,0-1c5.59-6.63,11-12.9,16.2-19.35C20.28.7,23.62.19,28.3,1.69a.78.78,0,0,1,.37,1.24L11.24,23.66a.77.77,0,0,0,0,1L28.85,45.79A.78.78,0,0,1,28.54,47c-4.26,1.75-7.4,1.59-10.29-1.94C12.69,38.28,7,31.61,1.15,24.7Z"
      transform="translate(-0.97 -0.9)"
    />
  </svg>
</template>

<script>
export default {
  name: "IconBack"
};
</script>

<style scoped></style>
